import { module } from 'modujs';
/*import Swiper, {Navigation,EffectFade,Autoplay} from "swiper";*/

export default class extends module {
    constructor(m) {
        super(m);


        /*new Swiper( this.$( 'swiper' )[0] , {
            modules: [Navigation,EffectFade,Autoplay],
            loop: true,
            speed: 1000,
            navigation: {
                prevEl: this.$( 'prev-button' )[0],
                nextEl: this.$( 'next-button' )[0],
            },
        });*/
    }


    destroy(){
    }
}
